/* eslint-disable import/prefer-default-export */
import env from 'utils/env';
import request from './request';

export const getSubscriptionPlans = () =>
  request(`${env.localization}/api/1/subscription/plans`);
